function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import moment from 'moment';
function rangeNumbers(from, to) {
  var result = [];
  for (var i = from; i <= to; i++) {
    result.push(i);
  }
  return result;
}
export function reorderArray(array, startIndex, endIndex) {
  var result = Array.from(array);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = _slicedToArray(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(endIndex, 0, removed);
  return result;
}
export function getPaginationOptions(currentPage, totalPages) {
  if (totalPages <= 7) {
    var pages = [];
    for (var i = 0; i < totalPages; i++) {
      pages.push(i + 1);
    }
    return pages;
  } else {
    // if the returned value is < 0 then it is '...' and not a page
    if ([1, 2].includes(currentPage)) {
      return [].concat(_toConsumableArray(rangeNumbers(1, 4)), [-1, totalPages]);
    } else if (currentPage === 3) {
      return [].concat(_toConsumableArray(rangeNumbers(1, 5)), [-1, totalPages]);
    } else if (currentPage === 4) {
      return [].concat(_toConsumableArray(rangeNumbers(1, 6)), [-1, totalPages]);
    } else if ([totalPages - 1, totalPages].includes(currentPage)) {
      return [1, -1].concat(_toConsumableArray(rangeNumbers(totalPages - 3, totalPages)));
    } else if (currentPage === totalPages - 2) {
      return [1, -1].concat(_toConsumableArray(rangeNumbers(currentPage - 2, totalPages)));
    } else if (currentPage === totalPages - 3) {
      return [1, -1].concat(_toConsumableArray(rangeNumbers(currentPage - 2, totalPages)));
    } else {
      return [1, -1].concat(_toConsumableArray(rangeNumbers(currentPage - 2, currentPage + 2)), [-2, totalPages]);
    }
  }
}
export function escapeAndParameterizeSlug(slug) {
  var validChars = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-", "_", "+", "|", " ", "Α", "Β", "Γ", "Δ", "Ε", "Ζ", "Η", "Θ", "Ι", "Κ", "Λ", "Μ", "Ν", "Ξ", "Ο", "Π", "Ρ", "Σ", "Τ", "Υ", "Φ", "Χ", "Ψ", "Ω", "α", "β", "γ", "δ", "ε", "ζ", "η", "θ", "ι", "κ", "λ", "μ", "ν", "ξ", "ο", "π", "ρ", "σ", "τ", "υ", "φ", "χ", "ψ", "ω", "ς", "ά", "έ", "ό", "ώ", "ί", "ή", "ύ", "ϊ", "ϋ", "ΐ", "ΰ", "Ά", "Έ", "Ό", "Ώ", "Ί", "Ή", "Ύ", "б", "в", "г", "д", "ж", "з", "к", "л", "м", "н", "п", "р", "с", "т", "ф", "х", "ц", "ч", "ш", "щ", "й", "а", "э", "ы", "у", "о", "я", "е", "ё", "ю", "и", "ь", "ъ"];
  var validSlug = '';
  for (var i = 0; i < slug.length; i++) {
    if (validChars.indexOf(slug[i]) > -1) {
      validSlug += slug[i];
    }
  }
  return validSlug.trim().toLowerCase().replace(/ /g, "-");
}
export function generateYoutubeLinkWithAttributes(video, videoSettings) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var videoId = video.match(regExp);
  var link = "https://www.youtube.com/embed/".concat(videoId ? videoId[7] : '', "?");
  Object.keys(videoSettings).map(function (attribute) {
    switch (attribute) {
      case 'showRelated':
        link += "&rel=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'showCaptions':
        link += videoSettings[attribute] ? '&cc_load_policy=1&cc_lang_pref=en' : '';
        break;
      case 'autoplay':
        link += "&autoplay=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'loop':
        link += videoSettings[attribute] ? "&loop=1&playlist=".concat(videoId) : '';
        break;
      case 'mute':
        link += "&mute=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'controls':
        link += "&controls=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'showFullscreen':
        link += "&fs=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'showLogo':
        link += "&modestbranding=".concat(!videoSettings[attribute] ? 1 : 0);
        break;
    }
  });
  return link;
}
export function generateVimeoLinkWithAttributes(video, videoSettings) {
  var regExp = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
  var videoId = video.match(regExp);
  var link = "https://player.vimeo.com/video/".concat(videoId ? videoId[1] : '', "?");
  Object.keys(videoSettings).map(function (attribute) {
    switch (attribute) {
      case 'autoplay':
        link += "&autoplay=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'showCaptions':
        link += videoSettings[attribute] ? '&texttrack=en' : '';
        break;
      case 'loop':
        link += "&loop=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'mute':
        link += "&muted=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'controls':
        link += "&controls=".concat(videoSettings[attribute] ? 1 : 0);
        break;
      case 'showFullscreen':
        link += "&fs=".concat(videoSettings[attribute] ? 1 : 0);
        break;
    }
  });
  return link;
}
export function emailValidation(email) {
  var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
  return re.test(email);
}
export function dynamicTableItemRenderer(item, column) {
  if (column.type === 'boolean') {
    return /*#__PURE__*/React.createElement("div", {
      key: column.label,
      className: "item flex-1"
    }, item[column.label] ? /*#__PURE__*/React.createElement("i", {
      className: "fa-light fa-circle-check"
    }) : /*#__PURE__*/React.createElement("i", {
      className: "fa-light fa-dash"
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      key: column.label,
      className: "item flex-1"
    }, item[column.label]);
  }
}
export function truncateString(str, num) {
  if (!str) {
    return '';
  }
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
}
export function generateId() {
  return String(Math.random()).substring(2, 12);
}
export function formatDate(date) {
  var splitDateAndTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!date) return '-';
  var utcDate = moment.utc(date, 'DD/MM/YYYY HH:mm:ss');
  if (utcDate.local().format('DD/MM/YYYY HH:mm') === 'Invalid date') {
    utcDate = moment.utc(moment(date), 'DD/MM/YYYY HH:mm:ss');
  }
  if (splitDateAndTime) {
    return {
      date: utcDate.local().format('DD/MM/YYYY'),
      time: utcDate.local().format('HH:mm')
    };
  }
  return utcDate.local().format('DD/MM/YYYY HH:mm');
}
export function constructPreviewLink(entity, allowMultilingual, defaultLocale, selectedLocale, translations) {
  var entityPath = entity ? "".concat(entity, "/") : '';
  if (!allowMultilingual) {
    return "/".concat(defaultLocale, "/").concat(entityPath).concat(translations[defaultLocale].slug);
  }
  var selectedTranslation = translations[selectedLocale];
  if (selectedTranslation && selectedTranslation.id && !selectedTranslation._destroy) {
    return "/".concat(selectedLocale, "/").concat(entityPath).concat(selectedTranslation.slug);
  }
  var locale = Object.keys(translations).find(function (locale) {
    return translations[locale].id && !translations[locale]._destroy;
  });
  return "/".concat(locale, "/").concat(entityPath).concat(translations[locale].slug);
}
export function mobileAppOrigin() {
  if (window.location.search.includes('origin=mobileApp')) {
    document.getElementsByClassName('header')[0].style.display = 'none';
    document.getElementsByClassName('sidenav')[0].style.display = 'none';
    document.getElementsByTagName('main')[0].style.width = '100%';
    document.getElementsByTagName('main')[0].style.marginTop = '0px';
    document.getElementsByTagName('main')[0].style.height = '100%';
  }
}
export function getTranslatableField(entity, field, currentLocale) {
  var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (entity.translations) {
    var currentTranslatableFields;
    if (currentLocale) {
      currentTranslatableFields = entity.translations.filter(function (t) {
        return t.locale === currentLocale;
      })[0];
    } else {
      currentTranslatableFields = entity.translations[0];
    }
    var firstTranslatableFields = entity.translations.filter(function (t) {
      return t[field];
    })[0];
    if (!fallback) {
      if (currentTranslatableFields) {
        return currentTranslatableFields[field] || '';
      } else {
        return '';
      }
    } else {
      if (currentTranslatableFields && currentTranslatableFields[field]) {
        return currentTranslatableFields[field] || '';
      } else if (firstTranslatableFields) {
        return firstTranslatableFields[field] || '';
      }
    }
  }
  return '';
}
export function getPlatformOriginIcon(platformKey) {
  var platforms = {
    android: {
      icon: 'fa-android',
      type: 'fab'
    },
    ios: {
      icon: 'fa-apple',
      type: 'fab'
    },
    pax: {
      icon: 'fa-mobile-notch',
      secondaryIcon: 'fa-terminal'
    },
    pos_terminal: {
      icon: 'fa-mobile-notch',
      secondaryIcon: 'fa-terminal'
    },
    api: {
      icon: 'fa-cloud'
    },
    web: {
      icon: 'fa-house-laptop'
    },
    admin: {
      icon: 'fa-user-tie'
    }
  };
  return platforms[platformKey] || {};
}
export function getEntityStatusIcons(statusKey) {
  var statusIcons = {
    completed: {
      icon: 'fa-circle-check',
      color: 'green'
    },
    cancelled: {
      icon: 'fa-circle-xmark',
      color: 'red'
    },
    failed: {
      icon: 'fa-circle-exclamation',
      color: 'red'
    },
    checkout: {
      icon: 'fa-hourglass',
      color: 'orange'
    },
    authorized: {
      icon: 'fa-hourglass',
      color: 'orange'
    },
    on_credit: {
      icon: 'fa-hourglass',
      color: 'orange'
    }
  };
  return statusIcons[statusKey] || {};
}
export function validateEmail(email) {
  var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
  return re.test(email);
}